(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function activate(root, tab) {
      var targetId = tab.getAttribute('aria-controls');
      root.querySelectorAll('.collections-tabs__tab').forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      root.querySelectorAll('.collections-tabs__panel').forEach(function (p) {
        var on = p.id === targetId;
        p.classList.toggle('is-active', on);
        p.hidden = !on;
      });
    }

    document.addEventListener('click', function (e) {
      var tab = e.target.closest('.collections-tabs__tab');
      if (!tab) return;
      activate(tab.closest('.collections-tabs'), tab);
    });

    document.addEventListener('keydown', function (e) {
      var tab = e.target.closest('.collections-tabs__tab');
      if (!tab) return;
      var keys = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
      if (keys.indexOf(e.key) === -1) return;
      e.preventDefault();
      var root = tab.closest('.collections-tabs');
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.collections-tabs__tab'));
      var i = tabs.indexOf(tab);
      if (e.key === 'ArrowRight') i = (i + 1) % tabs.length;
      else if (e.key === 'ArrowLeft') i = (i - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') i = 0;
      else i = tabs.length - 1;
      tabs[i].focus();
      activate(root, tabs[i]);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(root) {
      if (root.dataset.sliderInit) return;
      root.dataset.sliderInit = '1';

      var track = root.querySelector('[data-slider-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-slider-dot]'));
      if (!track || slides.length < 2) return;

      var index = 0;
      var timer = null;
      var paused = false;
      var autoplay = root.dataset.autoplay === 'true';
      var speed = (parseInt(root.dataset.autoplaySpeed, 10) || 5) * 1000;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function go(i) {
        index = (i + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + index * 100 + '%)';
        slides.forEach(function (s, si) {
          var on = si === index;
          s.classList.toggle('is-active', on);
          if (on) s.removeAttribute('aria-hidden');
          else s.setAttribute('aria-hidden', 'true');
          var link = s.querySelector('.hero-slider__link');
          if (link) link.tabIndex = on ? 0 : -1;
        });
        dots.forEach(function (d, di) {
          var on = di === index;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }

      function next() { go(index + 1); }
      function prev() { go(index - 1); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() { if (autoplay && !reduce && !paused) { stop(); timer = setInterval(next, speed); } }

      var nextBtn = root.querySelector('[data-slider-next]');
      var prevBtn = root.querySelector('[data-slider-prev]');
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });

      var toggleBtn = root.querySelector('[data-slider-toggle]');
      if (toggleBtn) {
        toggleBtn.addEventListener('click', function () {
          paused = !paused;
          toggleBtn.classList.toggle('is-paused', paused);
          toggleBtn.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
          if (paused) stop(); else start();
        });
      }
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          go(parseInt(d.dataset.sliderDot, 10));
          start();
        });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);

      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { next(); start(); }
        else if (e.key === 'ArrowLeft') { prev(); start(); }
      });

      var startX = null;
      var swiped = false;
      track.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        swiped = false;
        stop();
      }, { passive: true });
      track.addEventListener('touchmove', function (e) {
        if (startX === null) return;
        if (Math.abs(e.touches[0].clientX - startX) > 10) swiped = true;
      }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); }
        startX = null;
        start();
      }, { passive: true });
      // Each slide is wrapped in a link, so a swipe that ends as a tap would
      // both advance the carousel and navigate. Swallow that click in the
      // capture phase; the flag resets on the next touchstart.
      track.addEventListener('click', function (e) {
        if (!swiped) return;
        e.preventDefault();
        e.stopPropagation();
      }, true);

      go(0);
      start();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.hero-slider').forEach(initSlider);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
